import { render, staticRenderFns } from "./FinanceExpenses.vue?vue&type=template&id=bdb5684c&scoped=true&"
import script from "./FinanceExpenses.vue?vue&type=script&lang=js&"
export * from "./FinanceExpenses.vue?vue&type=script&lang=js&"
import style0 from "./FinanceExpenses.vue?vue&type=style&index=0&id=bdb5684c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb5684c",
  null
  
)

export default component.exports